import request from '@/plugins/request';
import axios from '@/plugins/axios';
export function kuaishou_video(params) {
    return request  ({
      url: '/api/kuaishou_video',
      method: 'get',
      params
    });
  }

  export function kuaishou_video2(params) {
    return request  ({
      url: '/api/kuaishou_video2',
      method: 'get',
      params
    });
  }

  export function kuaishou_video3(params) {
    return request  ({
      url: '/api/kuaishou_video3',
      method: 'get',
      params
    });
  }

   export function kuaishou_video8(params) {
    return request  ({
      url: '/api/kuaishou_video8',
      method: 'get',
      params
    });
  }

  export function kuaishou_video_comment(params) {
    return request  ({
      url: '/api/kuaishou_video_comment',
      method: 'get',
      params
    });
  }
  export function kuaishou_video_comment2(params) {
    return request  ({
      url: '/api/kuaishou_video_comment2',
      method: 'get',
      params
    });
  }

  export function kuaishou_video_comment3(params) {
    return request  ({
      url: '/api/kuaishou_video_comment3',
      method: 'get',
      params
    });
  }

   export function kuaishou_video_comment8(params) {
    return request  ({
      url: '/api/kuaishou_video_comment8',
      method: 'get',
      params
    });
  }


  export function delete_kuaishou_video(user_id) {
    return request({
      url: `/kuaishou_video/${user_id}`, // 使用模板字符串插入 taskId
      method: 'delete',
    });
  }
  
  export function delete_kuaishou_video_comment(user_id) {
    return request({
      url: `/kuaishou_video_comment/${user_id}`, // 使用模板字符串插入 taskId
      method: 'delete',
    });
  }